import { mapActions } from 'vuex';
import storageLocal, { USER_KEY, LANG_KEY } from '@/api/storage/local';

export default {
  data() {
    return {
      syncSession: null,
    };
  },
  mounted() {
    // Sync login/logout/lang across tabs
    this.syncSession = (evt) => {
      if (evt.key === USER_KEY) {
        const user = storageLocal.getUser();
        if (!user) {
          // logout case
          if (this.$router.currentRoute.path !== '/logout') {
            this.$router.push('/logout');
          }
        } else {
          // login case
          this.setUserProfile(user);
          if (this.$router.currentRoute.path === '/logout') {
            this.$router.push('/');
          }
        }
      }
      if (evt.key === LANG_KEY) {
        const lang = storageLocal.getLang();
        if (this.$lang !== lang) {
          this.setLang(lang);
        }
      }
    };
    window.addEventListener('storage', this.syncSession);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.syncSession);
  },
  methods: {
    ...mapActions('user', {
      setLang: 'setLang',
      setUserProfile: 'setUserProfile',
    }),
  },
};
